/* archivo de configuracion de las url dentro de la aplicacion  */

// import axios from 'axios';

const API_BASE_URL =
  process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL
    ? '' // Use relative path if in development and no explicit API_URL is set (relying on package.json proxy)
    : ''; // O tu REACT_APP_API_URL si está configurado para producción

const footer = API_BASE_URL + '/static/images/MIN.png';
const metadatos_recurso = '/metadatos/';
const visualizacion_recurso = metadatos_recurso + 'visualizacion-recurso/';
const metadatos_agrupaciones = '/metadatos-agrupaciones/';
const agregar_favoritos =
  metadatos_agrupaciones + 'agregar-recurso-favoritos-usuario/';
const login = '/cas/login/';
const bg_external =
  API_BASE_URL + '/static/images/resources/external-link-resource.png';

export const urls = {
  descargas_recursos: 'descargados',
  recursos: 'recursos',
  descargas_agrupaciones: 'descargados-agrupaciones',
  busqueda: 'catalogo',
  agrupaciones: 'agrupaciones',
  visualizacion_recurso: visualizacion_recurso,
  agregar_favoritos: agregar_favoritos,
  login: login,
  url_api: API_BASE_URL,
  footer: footer,
  bg_external: bg_external,
  colecciones: 'colecciones',
  getResourceNumberTimesSharedURL: resource_id => {
    return (
      API_BASE_URL + `/api/resource-objects/${resource_id}/number_times_shared/`
    );
  },
  getResourceNumberTimesViewedURL: resource_id => {
    return API_BASE_URL + `/api/resource-objects/${resource_id}/number_visits/`;
  },
  getResourceNumberTimesDownloadedURL: resource_id => {
    return (
      API_BASE_URL + `/api/resource-objects/${resource_id}/number_downloads/`
    );
  }
};
